import React, { Fragment, useEffect, useState } from 'react';
import Button from '~~elements/Button';
import TTMultilingual from './Multilingual';
import AssignPlayerManager from './AssignPlayerManager';
import { playerDefaultColumns } from '../Const';
import moment from 'moment';

const PlayerDisplay = ({
  editable,
  player,
  handlePlayerEdit,
  handlePlayerDelete,
  canBeClaimed = false,
  claimedCallback = () => {},
}) => {
  const [birthdayDisplay, setBirthdayDisplay] = useState('');
  const [showAssignPlayerManager, setShowAssignPlayerManager] = useState(false);

  useEffect(() => {
    const birthday = new Date(player.birthday);
    if (!player.birthday || !moment(birthday).isValid()) {
      setBirthdayDisplay('');
      return;
    }

    setBirthdayDisplay(moment(birthday).format('YYYY/MM/DD'));
  }, [player.birthday]);

  const openAssignPlayerModal = () => {
    setShowAssignPlayerManager(true);
  };

  const closeAssignPlayerModal = () => {
    setShowAssignPlayerManager(false);
  };

  return (
    <Fragment>
      {player.avatar_url ? (
        <img className="registration--item-avatar" src={player.avatar_url} alt="avatar" />
      ) : (
        <div className="registration--item-avatar default"></div>
      )}
      <div>
        {player.uniqid ? (
          <a
            href={`${process.env.REACT_APP_MAINPAGE_URL}/player/${player.uniqid}`}
            target="_blank"
            rel="noreferrer"
          >{`${player.name} #${player.number}`}</a>
        ) : (
          `${player.name} #${player.number}`
        )}
      </div>
      <div className="registration--item-meta">{`${TTMultilingual(`COLUMN.BIRTHDAY`)}: ${birthdayDisplay}`}</div>
      {Object.keys(playerDefaultColumns).map((columnName) => (
        <div className="registration--item-meta" key={columnName}>{`${TTMultilingual(
          `COLUMN.${columnName.toUpperCase()}`,
        )}: ${TTMultilingual(
          `${playerDefaultColumns[columnName]}.${!player[columnName] ? 'UNSET' : player[columnName]}`,
        )}`}</div>
      ))}
      {editable && (
        <div className="registration--item-control">
          <Button width="unset" nowrap color="blue" mini onClick={handlePlayerEdit}>
            {TTMultilingual(`COMMON.EDIT`)}
          </Button>
          <Button width="unset" nowrap color="red" mini onClick={handlePlayerDelete}>
            {TTMultilingual(`COMMON.DELETE`)}
          </Button>
        </div>
      )}
      {canBeClaimed && (
        <div className="registration--item-control">
          <Button width="unset" nowrap color="transparentWithBorder" mini onClick={openAssignPlayerModal}>
            {TTMultilingual(`ASSIGN_MANAGER`)}
          </Button>
        </div>
      )}
      {showAssignPlayerManager && (
        <AssignPlayerManager
          isOpen={true}
          toClose={closeAssignPlayerModal}
          player={player}
          claimedCallback={claimedCallback}
        />
      )}
    </Fragment>
  );
};

export default PlayerDisplay;
